import { createSelector } from 'reselect';
 
const selectTrainers = (state: any) => state.trainers;


export const selectTrainersCurrentItem = createSelector([selectTrainers], (trainers) => trainers.current);

export const selectTrainersListItems = createSelector([selectTrainers], (trainers) => trainers.list);

export const selectTrainersQueryItems = createSelector([selectTrainers], (trainers) => trainers.query);
export const selectTrainersItemById = (itemId: any) =>
    createSelector(selectTrainersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTrainersCreatedItem = createSelector([selectTrainers], (trainers) => trainers.create);

export const selectTrainersUpdatedItem = createSelector([selectTrainers], (trainers) => trainers.update);

export const selectTrainersReadItem = createSelector([selectTrainers], (trainers) => trainers.read);

export const selectTrainersDeletedItem = createSelector([selectTrainers], (trainers) => trainers.delete);

export const selectTrainersSearchedItems = createSelector([selectTrainers], (trainers) => trainers.search);

export const selectTrainersItemsCount = createSelector([selectTrainers], (trainers) => trainers.count);

export const selectTrainersItemsFilter = createSelector([selectTrainers], (trainers) => trainers.filter);